import { docReady } from '../helpers/docReady';
// Import global JS and CSS
import '../global';
import '../../styles/templates/cart.scss';
docReady(function () {
    //
});
